<div id="login" class="page container">
  <form name="loginForm" novalidate (ngSubmit)="forward()" autocomplete="off" [ngClass]="{'form-complete': isFormCompleted}">
    <h1>{{"copy.label.LOGIN.header"|copy|async}}</h1>
    <!-- <mtc-alert></mtc-alert> -->
    <div *ngIf="errorMsg" type="danger">
      <strong>
        <span class="fas fa-stack">
          <i class="fas fa-exclamation fa-stack-1x"></i>
          <i class="far fa-circle fa-stack-2x"></i>
        </span>
        {{errorMsg}}
      </strong>
    </div>
    <div class="content col-md-12">
      <div class="row">
        <div class="d-flex loginFlexContainer justify-content-between">
          <div class="login-info">
            <!--<p>{{"copy.html.logintext"|copy|async}} <a tabindex="0" (click)="openModal('attendeeDescriptions', 'Attendee Type Descriptions', 'Close')" (keydown.enter)="openModal('attendeeDescriptions', 'Attendee Type Descriptions', 'Close')" target="_blank">here</a> {{"copy.html.logintext2"|copy|async}}</p>

            <div [innerHTML]='"copy.html.logintext3"|copy|async'></div>-->


              <div [innerHTML]='"copy.html.logintextSiteClosed"|copy|async'></div>
          </div>
          <!-- <div [innerHTML]='"login.logintext"|copy|async' class="login-info"></div> -->

<!--
          <section class="agendaTabs" *ngIf="('OTP'|copy|async) ==='true'">
            <ul ngbNav #nav="ngbNav" [(activeId)]="active" class="nav-tabs">
              <li class="nav-item" [ngbNavItem]="1" *ngIf="!onsite">
                <button ngbNavLink>
                  <span class="day">
                    <div [innerHTML]="'copy.label.LOGIN.newlogin.header' | copy | async"></div>
                  </span>
                  <span class="curve"></span>
                </button>
                <ng-template ngbNavContent>
                  <app-initial-login></app-initial-login>
                </ng-template>
              </li>
              <li class="nav-item" [ngbNavItem]="2">
                <button ngbNavLink>
                  <span class="day">
                    <div [innerHTML]="'copy.label.OTP.emailEntry' | copy | async"></div>
                  </span>
                  <span class="curve"></span>
                </button>
                <ng-template ngbNavContent>-->
                  <!-- <app-rvs-confirmation-code *ngIf="('OTP'|copy|async) ==='false'"></app-rvs-confirmation-code> --><!--
                  <app-otp *ngIf="('OTP'|copy|async) ==='true'"></app-otp>
                </ng-template>
              </li>
            </ul>
            <div [ngbNavOutlet]="nav" class="mt-2"></div>
          </section>

-->
        </div>
      </div>
    </div>
  </form>
</div>
